import {create} from 'zustand'

export type TreatmentRequestDetailsGroup = 'diagnosis' | 'treatment' | 'scores' | 'notes'

type TreatmentRequestDetailsStore = {
    isErrorBannerVisible: boolean
    editingFieldsGroup: TreatmentRequestDetailsGroup | null
    setEditingFieldsGroup: (value: TreatmentRequestDetailsGroup | null) => void
    setIsErrorBannerVisible: (value: boolean) => void
}

export const useTreatmentRequestDetailsStore = create<TreatmentRequestDetailsStore>()(set => ({
    isErrorBannerVisible: false,
    editingFieldsGroup: null,
    setEditingFieldsGroup: value => set({editingFieldsGroup: value}),
    setIsErrorBannerVisible: value => set({isErrorBannerVisible: value})
}))
